/**
 * Blueprint for the google places object.
 */
export class GooglePlacesAddress {
  private city: string = '';
  private country: string = '';
  private postalCode: string = '';
  private street: string = '';

  public get getCity(): string {
    return this.city;
  }

  public set setCity(city: string) {
    this.city = city;
  }

  public get getCountry(): string {
    return this.country;
  }

  public set setCountry(country: string) {
    this.country = country;
  }

  public get getPostalCode(): string {
    return this.postalCode;
  }

  public set setPostalCode(postalCode: string) {
    this.postalCode = postalCode;
  }

  public get getStreet(): string {
    return this.street;
  }

  public set setStreet(street: object) {
    this.street = this.composeStreet(street);
  }

  /**
   * Compose street value with street name and street number.
   */
  private composeStreet(streetObj: any): string {
    let combinedStreet: string = '';

    if (streetObj.street !== null && streetObj.streetNumber !== null) {
      combinedStreet = `${streetObj.street} ${streetObj.streetNumber}`;
    } else if (streetObj.street !== null) {
      combinedStreet = streetObj.street;
    } else if (streetObj.streetNumber !== null) {
      combinedStreet = streetObj.streetNumber;
    }

    return combinedStreet;
  }
}

/**
 * Enum for Google Places API address type responses.
 */
export const enum GooglePlacesAddressType {
  StreetNumber = 'street_number',
  StreetName = 'route',
  PostalCity = 'postal_town',
  City = 'locality',
  PostalCode = 'postal_code',
  Country = 'country',
}
